import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { Container } from '../components/ui/Section';
import { CtaBand } from '../components/ui/CtaBand';
import { INDUSTRIES } from '../data/industries';
import { IMAGES } from '../data/solutions';
import { serviceJsonLd, useSeo } from '../utils/seo';
const CRUMBS = [{
  name: 'Inicio',
  path: '/'
}, {
  name: 'Industrias',
  path: '/industrias'
}];
export function Industries() {
  useSeo({
    title: 'Industrias | Servicios integrales por sector — Rabemar',
    description: 'Soluciones operativas para agroindustria, logística, transporte, industria, centros de distribución, depósitos, empresas corporativas, servicios, producción y comercio exterior.',
    path: '/industrias',
    image: IMAGES.team,
    breadcrumbs: CRUMBS,
    jsonLd: [serviceJsonLd('Servicios integrales por industria', 'Combinaciones de logística, transporte, Facility Management, HSE, tecnología y sustentabilidad según el sector del cliente.', '/industrias')]
  });
  return <>
      <PageHero eyebrow="Industrias" title="Cada sector tiene su punto de fricción. Empezamos por ahí." lead="La combinación de servicios cambia según la industria: lo que en una planta es continuidad productiva, en un centro de distribución es capacidad en pico y en agroindustria es estacionalidad y sanidad de instalaciones." image={IMAGES.team} imageAlt="Equipo de profesionales de operaciones con chalecos reflectantes en el área de muelles de un depósito" crumbs={CRUMBS} ctaLabel="Analizar mi operación" data-id="element-752" data-mp="1ve925yk9oq2b" />

      <section className="bg-white py-20 md:py-28" data-id="element-753" data-mp="20d3sdlkkdgwg">
        <Container data-id="element-754" data-mp="25bnkk3pr3ox9">
          <div className="grid gap-px bg-mist-200 md:grid-cols-2" data-id="element-755" data-mp="25b5d0axn1oa1">
            {INDUSTRIES.map((industry, i) => <article key={industry.slug} id={industry.slug} className="scroll-mt-24 bg-white p-8 md:p-10" data-id="element-756" data-mp="owvo9fphhxio" data-mpi={i}>
                <span className="font-display text-sm font-bold tabular-nums text-accent-500" data-id="element-757" data-mp="tv70ty75ym4l">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-graphite-900" data-id="element-758" data-mp="5uv6db6big37">{industry.name}</h2>
                <p className="mt-3 text-sm leading-relaxed text-graphite-500" data-id="element-759" data-mp="110u2st1l3e5">{industry.need}</p>
                <p className="mt-6 text-xs font-semibold uppercase tracking-[0.14em] text-graphite-500" data-id="element-760" data-mp="3s8whvse4kiss">
                  Combinación de servicios
                </p>
                <ul className="mt-3 space-y-1.5" data-id="element-761" data-mp="3i9xg8trs1nfa">
                  {industry.services.map(s => <li key={s} className="text-sm text-graphite-800" data-id="element-762" data-mp="3eaf0ecetc2jb">
                      · {s}
                    </li>)}
                </ul>
              </article>)}
          </div>
        </Container>
      </section>

      <CtaBand title="¿No ve su caso exacto?" text="El modelo se arma sobre la operación concreta, no sobre un paquete cerrado. Contamos con el diagnóstico como punto de partida." primaryLabel="Solicitar diagnóstico" location="industrias-cta" data-id="element-763" data-mp="17ixnymtx0a96" />
    </>;
}